export default __webpack_public_path__ + "static/media/icon_user-female.56c3c59b.svg";